<script setup>
const route = useRoute()
if (route.path !== '/zoom-map/') {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('zoom-map', '')
const breadCrumbList = [{ text: 'ライブカメラ', link: useCdnUrl('/') }, { text: 'マップ' }]
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <LivecamMapPlot />
      <LivecamAreaList />
      <LivecamFeature target-key="focus_livecam" />
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
